const indexItems = [
  { icon: 'ri-fire-line', label: '热门追踪', count: 128, desc: '当前最受关注的事件解读', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-user-star-line', label: '明星艺人', count: 96, desc: '娱乐圈艺人相关事件盘点', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-building-2-line', label: '企业揭秘', count: 74, desc: '企业内幕与商业事件解读', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-live-line', label: '直播带货', count: 63, desc: '直播行业事件与诚信盘点', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-shield-flash-line', label: '数据安全', count: 51, desc: '隐私泄露与安全事件分析', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-restaurant-line', label: '食品安全', count: 47, desc: '餐饮行业卫生与安全调查', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-bank-line', label: '金融财经', count: 42, desc: '金融领域违规事件梳理', color: 'bg-primary-100 text-primary-600' },
  { icon: 'ri-government-line', label: '社会民生', count: 39, desc: '社会热点事件深度剖析', color: 'bg-accent-100 text-accent-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            专题索引
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            按主题分类浏览，快速找到你感兴趣的事件解读
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#carousel"
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/60 hover:border-primary-200 hover:bg-background-50 transition-all duration-200"
            >
              <div className={`flex-shrink-0 w-11 h-11 flex items-center justify-center rounded-xl ${item.color}`}>
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.label}
                  </h3>
                  <span className="text-xs text-foreground-400">{item.count}篇</span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-1">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}